import React from 'react'
import cx from 'classnames'
import './styles.css'

export interface RollingMarqueeProps {
  data: {
    items?: string[]
    color?: string
  }
}

export const RollingMarquee: React.FC<RollingMarqueeProps> = ({ data }) => {
  const { items = [], color = '' } = data
  const rows = []
  const numberOfRows = 3
  const itemsPerRow = Math.ceil(items.length / numberOfRows)

  for (let i = 0; i < numberOfRows; i++) {
    rows.push(items?.slice(i * itemsPerRow, (i + 1) * itemsPerRow))
  }

  return (
    <div className="rolling-marquee-module">
      {rows?.map((rowItems, rowIndex) => {
        const repeatedItems: string[] = []
        for (let i = 0; i < 10; i++) {
          repeatedItems.push(...rowItems)
        }

        return (
          <div key={rowIndex} className={cx('marquee-row', `row-${rowIndex}`)}>
            <div className="marquee-content">
              {repeatedItems?.map((item, i) => (
                <React.Fragment key={i}>
                  <h3 className={cx('marquee-item', color)}>{item}</h3>
                </React.Fragment>
              ))}
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default RollingMarquee
